import Skeleton, { SkeletonScreen } from "../Skeleton";

// Esqueleto del panel mientras carga la cuenta: imita el Inicio (encabezado y tarjetas).
export const PanelSkeleton = () => {
  return (
    <SkeletonScreen label="Cargando tu cuenta…" className="lp-panel-page">
        <div className="lp-panel-head">
            <div>
                <Skeleton width={320} height={34}></Skeleton>
                <Skeleton width={420} height={16}></Skeleton>
            </div>
            <div className="lp-panel-head-actions">
                <Skeleton width={140} height={48} radius={999}></Skeleton>
                <Skeleton width={180} height={48} radius={999}></Skeleton>
            </div>
        </div>

        <div className="lp-panel-grid">
            {[3, 2, 4, 2].map((lines, i) => (
                <section key={i} className="lp-panel-card lp-panel-stack">
                    <Skeleton width="45%" height={22}></Skeleton>
                    {Array.from({ length: lines }, (_, l) => (
                        <Skeleton key={l} width={l === lines - 1 ? "60%" : "100%"} height={14}></Skeleton>
                    ))}
                    <Skeleton width={150} height={40} radius={999} style={{ marginTop: 4 }}></Skeleton>
                </section>
            ))}
        </div>
    </SkeletonScreen>
  )
}

// Datos del negocio y pestañas de la barra lateral (abajo en el celular) mientras carga.
export const PanelSideSkeleton = () => {
  return (
    <>
        <div className="lp-panel-side-biz" aria-hidden="true">
            <Skeleton width={40} height={40} radius={10}></Skeleton>
            <div>
                <Skeleton width={120} height={14}></Skeleton>
                <Skeleton width={70} height={18} radius={999}></Skeleton>
            </div>
        </div>
        <div className="lp-panel-nav lp-panel-nav-skel" aria-hidden="true">
            {Array.from({ length: 6 }, (_, i) => (
                <span key={i}>
                    <Skeleton width={22} height={22} radius={6}></Skeleton>
                    <Skeleton width={i === 3 ? 72 : 52} height={10}></Skeleton>
                </span>
            ))}
        </div>
    </>
  )
}
